import { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectHomeData, selectSpeedFormationSave, selectSpeedFormationDate } from '@/containers/HomePage/HomeSelectors'
import { setIsEditingSpeedFormation, setSpeedFormationDate } from '@/containers/HomePage/HomeSlice'
import { homeActions } from '@/containers/HomePage/HomeSagas'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { hasSpeedFormationDueDate } from '@/containers/HomePage/SpeedFormation/hasSpeedFormationDueDate'
import pickedDateAsUtc from '@/shared/tools/pickedDateAsUtc'

const useFormationForm = () => {
  const dispatch = useDispatch()
  const { speedFormation } = useSelector(selectHomeData)
  const { isLoading, error, errorMessage } = useSelector(selectSpeedFormationSave)
  const date = useSelector(selectSpeedFormationDate)
  const { country } = useSelector(selectAuthData)
  const hasDueDate = hasSpeedFormationDueDate(country)
  const editorRef = useRef(null)

  const setIsEditing = value => dispatch(setIsEditingSpeedFormation(value))
  const changeDate = ({ date: picked }) => {
    const utcDate = pickedDateAsUtc(picked)
    if (Number.isNaN(utcDate.getTime())) {
      return
    }
    dispatch(setSpeedFormationDate(utcDate.toISOString()))
  }

  const saveSpeedFormation = () => {
    if (!editorRef.current) {
      return
    }
    const text = editorRef.current.getContent()
    const formattedDate = hasDueDate ? new Date(date).toISOString().slice(0, 10) : null
    dispatch({ type: homeActions.SAVE_SPEED_FORMATION, text, date: formattedDate })
  }

  return {
    speedFormation,
    editorRef,
    date,
    changeDate,
    hasDueDate,
    setIsEditing,
    saveSpeedFormation,
    isLoading,
    error,
    errorMessage,
  }
}

export default useFormationForm
